module.exports = __webpack_public_path__ + "img/scene11.31131730.gif";